/** @jsx jsx */
import { Status, WarningFillIcon } from "@eworkit/iris";
import { FC } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { jsx } from "theme-ui";

import { PayCodeMeasureUnit } from "@/data/pay-codes";
import { TimeValidationError } from "@/data/time-reports";

interface TimeReportCalendarPayCodeRowCellValidationProps {
  error?: TimeValidationError;
  measureUnit: PayCodeMeasureUnit;
}

export const TimeReportCalendarPayCodeRowCellValidation: FC<TimeReportCalendarPayCodeRowCellValidationProps> = ({
  error,
  measureUnit,
}) => {
  const { t } = useTranslation("session");

  return (
    <Status variant="danger" iconLeft={<WarningFillIcon />}>
      {error === "WRONG_FORMAT" && (
        <React.Fragment>
          {measureUnit === "HOURLY" && t("TIME_REPORTS.CALENDAR.VALIDATION.HOURLY_FORMAT_MESSAGE")}
          {measureUnit === "DAILY" && t("TIME_REPORTS.CALENDAR.VALIDATION.DAILY_FORMAT_MESSAGE")}
        </React.Fragment>
      )}

      {error === "MAX_ONE_DAY" && t("TIME_REPORTS.CALENDAR.VALIDATION.DAILY_ONE_DAY_MESSAGE")}
    </Status>
  );
};
